// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Sidebar.css */

.sidebar {
  position: fixed;
  left: 0;
  top: 0;
  height: 100vh;
  width: 240px;
  background: var(--gray-900, #111827);
  color: #fff;
  display: flex;
  flex-direction: column;
  transition: width var(--transition-normal, 300ms), transform var(--transition-normal, 300ms);
  z-index: 100;
  overflow: hidden;
}

.sidebar.collapsed { width: 64px; }

.sidebar-overlay {
  display: none;
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.5);
  z-index: 99;
}

.sidebar-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem;
  border-bottom: 1px solid var(--gray-700, #374151);
  min-height: 60px;
}

.sidebar-logo {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.logo-text {
  font-size: 1.25rem;
  font-weight: 700;
  color: var(--primary-color, #4f46e5);
  white-space: nowrap;
}

.sidebar-toggle {
  background: none;
  border: none;
  color: var(--gray-400, #9ca3af);
  cursor: pointer;
  padding: 0.25rem;
  border-radius: var(--radius-sm, 0.375rem);
  transition: color var(--transition-fast, 150ms);
  flex-shrink: 0;
}
.sidebar-toggle:hover { color: #fff; }
.sidebar-toggle svg { width: 20px; height: 20px; }

.sidebar-nav {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  overflow-y: auto;
  padding: 0.5rem 0;
}

.sidebar-menu {
  list-style: none;
  margin: 0;
  padding: 0;
}

.sidebar-item {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  width: 100%;
  padding: 0.75rem 1rem;
  border: none;
  background: none;
  color: var(--gray-400, #9ca3af);
  cursor: pointer;
  font-size: 0.95rem;
  transition: all var(--transition-fast, 150ms);
  text-align: left;
  white-space: nowrap;
  font-family: inherit;
}

.sidebar-item:hover {
  background: rgba(255,255,255,0.08);
  color: #0077ff;
}

.sidebar-item.active {
  background: rgba(79,70,229,0.15);
  color: var(--primary-color, #4f46e5);
  border-right: 3px solid var(--primary-color, #4f46e5);
}

.sidebar-item.logout-item:hover {
  background: rgba(239,68,68,0.15);
  color: var(--error-color, #ef4444);
}

.sidebar-icon { font-size: 1.25rem; width: 24px; text-align: center; flex-shrink: 0; }
.sidebar-label { overflow: hidden; text-overflow: ellipsis; }

.sidebar-bottom {
  border-top: 1px solid var(--gray-700, #374151);
  padding-top: 0.5rem;
}

/* ---- Mobile ---- */
@media (max-width: 767px) {
  .sidebar {
    transform: translateX(-100%);
    width: 260px;
  }

  .sidebar.mobile-open {
    transform: translateX(0);
  }

  .sidebar.collapsed {
    width: 260px; /* su mobile, collapsed non conta: la sidebar e' off-screen */
  }

  .sidebar-toggle { display: none; }

  .sidebar-overlay { display: block; }
}
`, "",{"version":3,"sources":["webpack://./src/components/dashboard/Sidebar.css"],"names":[],"mappings":"AAAA,gBAAgB;;AAEhB;EACE,eAAe;EACf,OAAO;EACP,MAAM;EACN,aAAa;EACb,YAAY;EACZ,oCAAoC;EACpC,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,4FAA4F;EAC5F,YAAY;EACZ,gBAAgB;AAClB;;AAEA,qBAAqB,WAAW,EAAE;;AAElC;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,2BAA2B;EAC3B,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,aAAa;EACb,iDAAiD;EACjD,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,yCAAyC;EACzC,+CAA+C;EAC/C,cAAc;AAChB;AACA,wBAAwB,WAAW,EAAE;AACrC,sBAAsB,WAAW,EAAE,YAAY,EAAE;;AAEjD;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,qBAAqB;EACrB,YAAY;EACZ,gBAAgB;EAChB,+BAA+B;EAC/B,eAAe;EACf,kBAAkB;EAClB,6CAA6C;EAC7C,gBAAgB;EAChB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,gCAAgC;EAChC,oCAAoC;EACpC,qDAAqD;AACvD;;AAEA;EACE,gCAAgC;EAChC,kCAAkC;AACpC;;AAEA,gBAAgB,kBAAkB,EAAE,WAAW,EAAE,kBAAkB,EAAE,cAAc,EAAE;AACrF,iBAAiB,gBAAgB,EAAE,uBAAuB,EAAE;;AAE5D;EACE,8CAA8C;EAC9C,mBAAmB;AACrB;;AAEA,qBAAqB;AACrB;EACE;IACE,4BAA4B;IAC5B,YAAY;EACd;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,YAAY,EAAE,6DAA6D;EAC7E;;EAEA,kBAAkB,aAAa,EAAE;;EAEjC,mBAAmB,cAAc,EAAE;AACrC","sourcesContent":["/* Sidebar.css */\n\n.sidebar {\n  position: fixed;\n  left: 0;\n  top: 0;\n  height: 100vh;\n  width: 240px;\n  background: var(--gray-900, #111827);\n  color: #fff;\n  display: flex;\n  flex-direction: column;\n  transition: width var(--transition-normal, 300ms), transform var(--transition-normal, 300ms);\n  z-index: 100;\n  overflow: hidden;\n}\n\n.sidebar.collapsed { width: 64px; }\n\n.sidebar-overlay {\n  display: none;\n  position: fixed;\n  inset: 0;\n  background: rgba(0,0,0,0.5);\n  z-index: 99;\n}\n\n.sidebar-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 1rem;\n  border-bottom: 1px solid var(--gray-700, #374151);\n  min-height: 60px;\n}\n\n.sidebar-logo {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n}\n\n.logo-text {\n  font-size: 1.25rem;\n  font-weight: 700;\n  color: var(--primary-color, #4f46e5);\n  white-space: nowrap;\n}\n\n.sidebar-toggle {\n  background: none;\n  border: none;\n  color: var(--gray-400, #9ca3af);\n  cursor: pointer;\n  padding: 0.25rem;\n  border-radius: var(--radius-sm, 0.375rem);\n  transition: color var(--transition-fast, 150ms);\n  flex-shrink: 0;\n}\n.sidebar-toggle:hover { color: #fff; }\n.sidebar-toggle svg { width: 20px; height: 20px; }\n\n.sidebar-nav {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  overflow-y: auto;\n  padding: 0.5rem 0;\n}\n\n.sidebar-menu {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n\n.sidebar-item {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  width: 100%;\n  padding: 0.75rem 1rem;\n  border: none;\n  background: none;\n  color: var(--gray-400, #9ca3af);\n  cursor: pointer;\n  font-size: 0.95rem;\n  transition: all var(--transition-fast, 150ms);\n  text-align: left;\n  white-space: nowrap;\n  font-family: inherit;\n}\n\n.sidebar-item:hover {\n  background: rgba(255,255,255,0.08);\n  color: #0077ff;\n}\n\n.sidebar-item.active {\n  background: rgba(79,70,229,0.15);\n  color: var(--primary-color, #4f46e5);\n  border-right: 3px solid var(--primary-color, #4f46e5);\n}\n\n.sidebar-item.logout-item:hover {\n  background: rgba(239,68,68,0.15);\n  color: var(--error-color, #ef4444);\n}\n\n.sidebar-icon { font-size: 1.25rem; width: 24px; text-align: center; flex-shrink: 0; }\n.sidebar-label { overflow: hidden; text-overflow: ellipsis; }\n\n.sidebar-bottom {\n  border-top: 1px solid var(--gray-700, #374151);\n  padding-top: 0.5rem;\n}\n\n/* ---- Mobile ---- */\n@media (max-width: 767px) {\n  .sidebar {\n    transform: translateX(-100%);\n    width: 260px;\n  }\n\n  .sidebar.mobile-open {\n    transform: translateX(0);\n  }\n\n  .sidebar.collapsed {\n    width: 260px; /* su mobile, collapsed non conta: la sidebar e' off-screen */\n  }\n\n  .sidebar-toggle { display: none; }\n\n  .sidebar-overlay { display: block; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
